import { CanDeactivateFn } from '@angular/router';

export const canDeactivateGuard: CanDeactivateFn<any> = (component) => {
  if (component.canDeactivate instanceof Function) {
    return component.canDeactivate();
  }
  return true;
};